// @ts-nocheck
import Time from '@/utils/time';
import * as Enums from '@/utils/enums';
import styles from './CustomerZoneHome.module.css';

const PILL_CLASS: Record<string, string> = {
  ok:     styles.pillOk,
  warn:   styles.pillWarn,
  danger: styles.pillDanger,
  info:   styles.pillInfo,
};

export function invoiceStatusDisplay(status: number): { label: string; tone: string } {
  switch (status) {
    case Enums.InvoiceStatus.Paid:      return { label: 'Paid',      tone: 'ok' };
    case Enums.InvoiceStatus.Unpaid:    return { label: 'Unpaid',    tone: 'danger' };
    case Enums.InvoiceStatus.Overdue:   return { label: 'Overdue',   tone: 'danger' };
    case Enums.InvoiceStatus.Cancelled: return { label: 'Cancelled', tone: 'danger' };
    case Enums.InvoiceStatus.Draft:     return { label: 'Draft',     tone: 'info' };
    default:                            return { label: 'Invoice',   tone: 'info' };
  }
}

export function quoteStatusDisplay(status: number): { label: string; tone: string } {
  switch (status) {
    case Enums.QuoteStatus.Accepted:  return { label: 'Accepted',  tone: 'ok' };
    case Enums.QuoteStatus.Invoiced:  return { label: 'Invoiced',  tone: 'ok' };
    case Enums.QuoteStatus.Declined:  return { label: 'Declined',  tone: 'danger' };
    case Enums.QuoteStatus.Expired:   return { label: 'Expired',   tone: 'danger' };
    case Enums.QuoteStatus.Cancelled: return { label: 'Cancelled', tone: 'danger' };
    case Enums.QuoteStatus.Approved:  return { label: 'Pending',   tone: 'warn' };
    case Enums.QuoteStatus.Draft:     return { label: 'Draft',     tone: 'info' };
    default:                          return { label: 'Quote',     tone: 'info' };
  }
}

export function deriveStatusTone(desc: string): string {
  const s = (desc || '').toLowerCase();
  if (s.includes('close') || s.includes('complet') || s.includes('done') || s.includes('paid')) return 'ok';
  if (s.includes('overdue') || s.includes('declin')) return 'danger';
  if (s.includes('pend') || s.includes('hold') || s.includes('wait')) return 'warn';
  return 'info';
}

export function getJobAppointment(job: any, now: any) {
  const apps = (job.Appointments || [])
    .filter((x: any) => x.IsActive)
    .sort((a: any, b: any) => (a.StartDateTime > b.StartDateTime ? 1 : -1));
  if (!apps.length) return null;
  const today = now ? Time.parseDate(Time.today(now)) : new Date();
  const tomorrow = new Date(today);
  tomorrow.setDate(tomorrow.getDate() + 1);
  const todayApps = apps.filter((x: any) => {
    const d = Time.parseDate(x.StartDateTime);
    return d >= today && d < tomorrow;
  });
  if (todayApps.length) return todayApps[0];
  const future = apps.filter((x: any) => Time.parseDate(x.StartDateTime) >= tomorrow);
  return future[0] || apps[apps.length - 1];
}

export function IconPenSign({ size = 14 }: { size?: number }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M3 17c2-4 4-4 5-1s3 3 5-1 4-4 5 0"/>
      <path d="M4 21h16"/>
    </svg>
  );
}

export function StatusPill({ text, tone }: { text: string; tone: string }) {
  return (
    <span className={`${styles.pill} ${PILL_CLASS[tone] || styles.pillInfo}`}>
      {text}
    </span>
  );
}

export function MiniRow({ icon, children }: { icon: React.ReactNode; children: React.ReactNode }) {
  return (
    <div className={styles.miniRow}>
      <span className={styles.miniRowIcon}>{icon}</span>
      <span>{children}</span>
    </div>
  );
}

export function MiniCard({ onClick, href, title, tone, statusText, rows }: {
  onClick: () => void;
  href: string;
  title: string;
  tone: string;
  statusText?: string;
  rows: React.ReactNode;
}) {
  return (
    <a
      className={styles.miniCard}
      href={href}
      onClick={(e) => {
        if (e.ctrlKey || e.metaKey || e.shiftKey) return;
        e.preventDefault();
        onClick();
      }}
    >
      <div className={styles.miniHead}>
        <span className={styles.miniTitle}>{title}</span>
        {statusText && <StatusPill text={statusText} tone={tone} />}
      </div>
      <div className={styles.miniRows}>{rows}</div>
    </a>
  );
}

export function RailCard({ iconClass, icon, title, strong, body, action }: {
  iconClass: string;
  icon: React.ReactNode;
  title: string;
  strong?: string;
  body?: string;
  action: React.ReactNode;
}) {
  return (
    <div className={styles.railCard}>
      <span className={`${styles.railCardIcon} ${iconClass}`}>{icon}</span>
      <span className={styles.railCardBody}>
        <h3 className={styles.railCardTitle}>{title}</h3>
        {strong && <span className={styles.railCardStrong}>{strong}</span>}
        {body && <p className={styles.railCardText}>{body}</p>}
        {action}
      </span>
    </div>
  );
}
